import { http } from '@/http'

export default {
  list(params)             { return http.get('/document-types', { params }) },
  get(id)                  { return http.get(`/document-types/${id}`) },
  save(data)               { return http.post('/document-types', data) },
  update(id, data)         { return http.put(`/document-types/${id}`, data) },
  changeStatus(id, status) { return http.put(`/document-types/${id}/status`, null, { params: { status } }) },

  // CDEF011: plantillas de los tipos GENERATED (todas las versiones; las inactivas siguen descargables).
  templates(typeId)                 { return http.get(`/document-types/${typeId}/templates`) },
  uploadTemplate(typeId, formData)  {
    return http.post(`/document-types/${typeId}/templates`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  deactivateTemplate(typeId, id)    { return http.put(`/document-types/${typeId}/templates/${id}/deactivate`) },
  downloadTemplate(typeId, id)      { return http.get(`/document-types/${typeId}/templates/${id}/file`, { responseType: 'blob' }) },
}
